import "./datatable.scss"
import React from 'react'
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";

type Props = {
    columns: GridColDef[];
    rows: object[];
    slug: string;
    header: string;
}

const DataTable = (props: Props) => {

    const handleDelete = (_id:number) => {
        //axios.delete(`/api/${slug}/id`)
        console.log(_id + " wurde gelöscht!")
    }

    const actionColumn: GridColDef = {
        field: "action",
        headerName: "Aktionen",
        width: 200,
        type: "actions",
        renderCell: (params) => {
            return <div className="action">
                <Link to={`/${props.slug}/${params.row._id}`}>
                    <img src="/edit.svg" alt="" />
                </Link>
              <div className="delete" onClick={()=>handleDelete(params.row._id)}>
                <img src="/delete.svg" alt="" />
              </div>
            </div>
          }
    }
    return (
        <div className="dataTable">
            <DataGrid className="dataGrid"
                rows={props.rows}
                columns={[...props.columns, actionColumn]}
                getRowId={(row) => row._id}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                showToolbar
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                    }
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnSelector
            />
        </div>
    )
}

export default DataTable